// Spanish (Spain)

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `abierta hasta ${date}` : ''),
    },
    interview: {
      title: 'Responder la video entrevista',
      submit: 'Enviar respuestas y completar la entrevista',
      continueLater: 'Continuar después',
      startInterview: 'Comenzar la entrevista',
      duplicateError: 'Ya has participado en esta entrevista. Has recibido un correo electrónico de invitations@recright.com que contiene un enlace que puede usarse para continuar la entrevista.',
      confirmSubmitHeader: 'No has respondido todas las preguntas de la entrevista',
      confirmSubmitContent: '¿De verdad quieres terminar la entrevista?',
      confirmSubmitContentWarning: 'Después de esto, no podrás completar tus respuestas.',
      submitInterviewHeader: 'Enviar sus respuestas a la entrevista',
      submitInterviewContent: '¿Seguro que desea enviar su entrevista?',
      confirmSubmitButton: 'Enviar respuestas y completar la entrevista',
      preview: 'Puedes previsualizar las preguntas del vídeo aquí.',
      requiredQuestionsNotAnswered: 'Por favor, responde a todas las preguntas obligatorias antes de enviar.',

      withdrawLink: '¿Ya no te interesa este puesto? Retírate del proceso aquí.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Número telefónico',
      city: 'Ciudad',
      link: 'Enlace',
      legendBasicInfo: 'Información básica',
      placeholderName: 'Escribe tu nombre',
      placeholderEmail: 'Ingresa tu correo electrónico',
      placeholderPhone: 'Ingresa tu número telefónico',
      placeholderCity: 'Introduce tu lugar de residencia actual',
      placeholderLink: 'Agregar enlace, por ejemplo, tu perfil de LinkedIn.',
      legendAttachments: 'Archivos adjuntos',
      legendAdditionalFields: 'Información adicional',
      required: 'Los elementos marcados con * asterisco son obligatorios.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Audio',
        video: 'Vídeo',
        yes: 'Sí',
        no: 'No',
        supported: 'Compatible',
        quality: 'Calidad',
        header: 'Prueba de conexión de red y de dispositivo',
        description: 'Ahora realizaremos una prueba para asegurarnos de que tu conexión de red y hardware que necesitas para la entrevista (cámara y teléfono) funcionen correctamente. Cuando se te pida, otorga el permiso para que probemos tanto la cámara como el micrófono. Asegúrate de que la cámara no esté tapada. La prueba durará unos 30 segundos. Te recomendamos que hables durante la prueba de hardware.',
        inProgress: 'Prueba en curso...',
        networkTestResults: 'Resultados de la prueba de red',
        qualityTestResults: 'Resultados de la prueba de calidad',
        testPassedQuality: 'Prueba de calidad aprobada',
        testFailedQuality: 'La prueba de calidad ha fallado',
        testPassedNetwork: 'La prueba de red se ha realizado correctamente',
        testFailedNetwork: 'Prueba de red suspensa',
        startTest: 'Comenzar la prueba',
        startInterview: 'Comenzar la entrevista',
        testAgain: 'Volver a realizar la prueba',
        confirmWarning: 'Cuando la videoentrevista comience, podrás ver de forma automática la primera pregunta de la misma. Tras ver la pregunta, pasarás a la preparación.',
        confirmTitle: 'Estás a punto de comenzar la entrevista',
        confirmText: 'Tienes un breve período de tiempo para preparar la respuesta antes de cada pregunta. Tras la preparación, tienes un tiempo predeterminado para contestar a la misma. Ten en cuenta que puedes enviar tu respuesta en cuanto la tengas preparada, incluso antes de que termine el período de tiempo establecido.',
        confirmText2: 'Tras enviar tu respuesta, pasarás a la siguiente hasta que no queden preguntas.',
        confirmText3:
          'Tenga en cuenta que después de grabar su respuesta a una pregunta y en el caso de que se permita repetir la pregunta, sólo dispondrá de 30 segundos para volver a contestar. Si no inicia la repetición de una pregunta dentro de este periodo de 30 segundos, su respuesta actual se enviará de forma automática y se le redirigirá a la siguiente.',
        goodLuck: 'Respira hondo, todo saldrá bien. ¡Buena suerte!',
        qualityRating: {
          excellent: 'Excelente',
          good: 'Bien',
          fair: 'Aceptable',
          poor: 'Pobre',
          bad: 'Mal',
        },
      },
      questionAnswerView: {
        title: title => `Respuesta a la entrevista ${title}`,
        question: 'Pregunta',
        submitAndNext: 'Enviar y pasar a la siguiente',
        submitSuccess: '¡Se ha enviado el vídeo correctamente!',
        skipText: 'Comenzar a grabar',
        stop: 'Parar',
        submitAndFinish: 'Enviar y terminar la entrevista',
        retake: 'Repetir',
        take: 'Realizar',
        takesLeft: 'Repeticiones restantes',
        skipTextQuestion: '¿Todo listo? Avanzar',
        retakeConfirmTitle: '¿Está seguro de que quiere volver a responder esta pregunta?',
        retakeConfirmSubmit: 'Sí, responder de nuevo',
        submitInfoForward: 'Enviar su respuesta actual de forma automática y avanzar en',
        submitInfoForward2: 'segundos',
        nonAnswerableText: 'Este mensaje no requiere respuesta. Después de este mensaje, pasarás directamente a la siguiente pregunta.',
        nonAnswerableVideo: 'Este vídeo no requiere respuesta. Después de este vídeo, pasarás directamente a la siguiente pregunta.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Dispone de ${answerMinutes} minutos y ${answerSeconds} segundos para responder a la pregunta.`,
      },
      publisher: {
        toNextQuestion: timer => `Se pasará a la siguiente pregunta en ${timer}`,
        recordingStarts: timer => `La grabación comienza en ${timer}`,
      },
      errors: {
        tooManyConnections: 'Se ha cerrado esta conexión porque ya tienes otra conexión abierta en otra pestaña o ventana.',
        unsupportedBrowser: 'Desafortunadamente, esta operación no es compatible con tu navegador. Utiliza otro navegador diferente.',
        networkError: 'Sin conexión a Internet.',
        reconnecting: 'Se ha interrumpido la conexión. Volviendo a conectar.',
        generalError: 'Algo ha fallado. Actualiza la página y vuélvelo a intentar.',
        allowMediaDevicesError: 'Error al obtener dispositivos multimedia (cámara o micrófono). Asegúrate de haber otorgado los permisos correspondientes al navegador para que pueda utilizar tu cámara y micrófono.',
        noAvailableDevicesError: 'No se ha encontrado una cámara ni micrófono.',
        initPublisherError: 'Fallo en la operación debido a un error. Asegúrate de que tu navegador tiene permisos para usar la cámara y el micrófono y que estos no están siendo utilizados por otra aplicación e inténtalo de nuevo.',
      },
      browserInfo: {
        browserSupportTitle: 'Compatibilidad con el navegador',
        supportedBrowsers: 'Esta prueba y entrevista son compatibles con las últimas versiones de Chrome, Firefox, Safari y Edge.',
        mobileSupported: 'Navegadores compatibles en teléfonos móviles',
        android: 'Android: Google Chrome (última versión), Firefox (última versión)',
        iOS: 'iOS: Safari (última versión)',
        latestVersion: 'Asegúrate de que utilizas la última versión del navegador. Esto hará que todo funcione correctamente.',
        freezeInstruction: 'Si la grabación de vídeo no comienza o la pantalla de grabación permanece en negro, actualiza la página.',
        unsupportedOnIos: 'Parece que utilizas un navegador no compatible en iOS. Utiliza Safari.',
        ieUnsupported: 'Parece que utilizas Internet Explorer. Desafortunadamente, Internet Explorar no es compatible para esta prueba o entrevista. Utiliza un navegador diferente.',
        qualityTestNotSupported: 'Desgraciadamente, la prueba de hardware no es compatible con el navegador que utilizas. Puedes continuar a la entrevista sin realizar la prueba de calidad de audio y de vídeo, o utilizar un navegador diferente.',
      },
      reconnectSuccess: '¡Se ha vuelto a conectar correctamente!',
      continue: 'Continuar',
    },

    withdraw: {
      title: '¿Ya no te interesa este puesto?',
      description: 'Retírate del proceso de selección.',
      buttonText: 'Retirarse del proceso de selección',
      thankYouTitle: '¡Gracias!',
      thankYouText: 'Has informado de que ya no te interesa este puesto.',
      confirm: '¿Seguro que quieres retirarte del proceso de selección? Tras retirarte del mismo, no podrás responder a esta entrevista ni a ninguna otra relacionada con este puesto.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Enviar',
      continue: 'Continuar',
      supportCenter: 'Recright Help Center',
      thankYou:
        '¡Gracias por tu video respuesta! ¡Nos pondremos en contacto contigo en un futuro cercano!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: '¡Gracias por participar en la entrevista!',
      reopenDescription: 'Si cierras esta entrevista involuntariamente, ¡no te preocupes! ¡Haz clic en el botón a continuación para reabrirla!',
      reopenButtonText: 'Reabrir entrevista',
      description1: 'Fantástico, has contestado a todas nuestras preguntas y se las hemos enviado al destinatario.',
      descriptionsupport: mailto => `Si has cerrado esta entrevista por accidente, comunícate con nuestro servicio de atención al cliente ${mailto} y volveremos a abrir tu entrevista.`,
      descriptionfeedback: '¡Tu experiencia es importante para nosotros! ¿Cómo ha sido tu experiencia respondiendo a la video entrevista? ¿Cómo mejorarías nuestro servicio? Deja tus comentarios aquí.',
      feedbackbutton: '¡Déjanos tu opinión!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Mensaje personal',
    },
    closed: {
      title: 'La entrevista se ha completado o la entrevista ha terminado',
      description: 'La video entrevista a la que fuiste invitado ya ha finalizado o has completado tu envío.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: '¡Tu video entrevista ahora está guardada!',
      description: 'Cuando desees continuar con la video entrevista, usa el enlace que recibiste anteriormente en tu correo electrónico. ¡Las respuestas de video ya grabadas estarán disponibles cuando regreses! ¡Buena suerte en tu búsqueda de empleo!',
      remember: 'Recuerda enviar las respuestas al recruiter después de que hayas terminado de contestar la entrevista.',
      deleteHistory: 'Si estás haciendo una video entrevista en una computadora pública, recuerda borrar tu historial de navegación. De esta forma tu entrevista está segura.',
    },
    unpublished: {
      title: 'La entrevista aún no se ha abierto',
      publishTime: publishTime => `Apertura de la entrevista: ${publishTime}`,
    },
  },
}
